<template>
    <a-menu
        mode="inline" :inlineIndent="64"
        :selectedKeys="[ $route.meta.key || '' ]"
        :style="{ height: '100%', borderRight: 0 }"
        @select="switchPanel"
    >
        <a-menu-item v-for="page of pages" :key="page.name">
            <a-icon :type="page.meta.icon" />
            <span>{{ page.meta.title }}</span>
        </a-menu-item>
    </a-menu>
</template>

<script>
import { pages } from "../router";

export default {
    data: () => ({
        pages
    }),
    methods: {
        switchPanel({ key }) {
            this.$router.push({ name: key });
        },
    }
}
</script>

<style>

</style>